import {
  CameraStates,
  THREE
} from '@powerplay/core-minigames'

/**
 * Konfig pre kameru pre vsetky stavy
 */
export const cameraConfig = {

  /** Nastavenie pozicii a pohybov kamery pre vsetky stavy */
  tweenSettingsForCameraStates: {
    [CameraStates.intro]: {
      startPosition: new THREE.Vector3(-38.02613067626953, 14.458897590637207, 49.266021728515625),
      endPosition: new THREE.Vector3(17.26425552368164, 13.679853439331055, 35.063507080078125),
      startRotation: new THREE.Vector3(1.5724543926639971, -0.14304559606820816, 0.2762097160457175),
      endRotation: new THREE.Vector3(1.5814590459473745, 0.08864844862197782, -0.2187717217253278),
      duration: 3,
      notSkippableFrames: 20,
      fov: 52
    },
    [CameraStates.intro2]: {
      startPosition: new THREE.Vector3(-4.9759111404418945, 3.6293323040008545, 1.49824059009552),
      endPosition: new THREE.Vector3(18.410503387451172, 22.469364166259766, -56.212440490722656),
      startRotation: new THREE.Vector3(1.6899891276893857, -0.04845118728963148, 0.005295988953101271),
      endRotation: new THREE.Vector3(1.7495792270179176, 0.07923508787467562, -0.17832592850360585),
      duration: 3,
      notSkippableFrames: 20,
      fov: 48
    },
    [CameraStates.table]: {
      startPosition: new THREE.Vector3(32.262088775634766, 5.859203338623047, -28.37641143798828),
      endPosition: new THREE.Vector3(26.720802307128906, 10.567830085754395, -64.62519836425781),
      startRotation: new THREE.Vector3(1.4644413867580544, 0.03223500287910954, -0.7692769089647064),
      endRotation: new THREE.Vector3(1.4235246889992852, 0.2253289866879297, -1.1774247941527403),
      fov: 49,
      duration: 5
    },
    [CameraStates.disciplineIntro]: {
      startPosition: new THREE.Vector3(2.5810468196868896, 0.8949797749519348, -95.74894714355469),
      endPosition: new THREE.Vector3(1.471549391746521, 0.8949797749519348, -97.16735076904297),
      startRotation: new THREE.Vector3(1.5659386134282096, -0.01776911622677761, -2.123564379100446),
      endRotation: new THREE.Vector3(1.5602686916024213, -0.01812027421306145, -2.3487921859102703),
      duration: 3,
      fov: 40
    },
    [CameraStates.disciplineIntroSecond]: {
      startPosition: new THREE.Vector3(-9.031318664550781, 0.052539825439453125, -86.0403823852539),
      endPosition: new THREE.Vector3(-9.25487995147705, 0.8697963356971741, -86.22840881347656),
      startRotation: new THREE.Vector3(1.6653123630050688, 0.11362457098238816, 0.6812352310478855),
      endRotation: new THREE.Vector3(1.5683489796690417, 0.03568957109080378, 0.7276728471129429),
      duration: 3,
      fov: 40
    },
    [CameraStates.discipline]: undefined,
    [CameraStates.disciplineOutro]: {
      // startPosition: new THREE.Vector3(-2, 2, 3),
      startPosition: new THREE.Vector3(6, 2, 0),
      // endPosition: new THREE.Vector3(2, 2, 3),
      endPosition: new THREE.Vector3(6, 2, 0),
      duration: 10,
      offsetCamera: true
    },
    [CameraStates.static]: undefined
  },
  distanceFromGround: 1.5,

  // zablesky fotakov
  flashes: {

    // zablesky budu kazdy x-ty frame
    everyXframe: 3,

    // Aky bude posun offsetu
    offsetShift: {
      min: 0.01,
      max: 0.03
    }

  },

  speedLock: {

    /** coef na slowmo */
    coefCameraChange: 0.1,

    /** offset kamery pri speedLocku */
    cameraOffset: new THREE.Vector3(5, 2, 0),

    /** coef na slowmo */
    speedLockCoefFinishLine: 0.88,

    /** cas v s za aky sa presunie kamera */
    cameraTransitionDuration: 2,

  },

  // kamera pri lete ostepu
  javelinFlight: {

    /** offset kamery pri speedLocku */
    cameraOffset: new THREE.Vector3(8, 2, 0),

    /** Aky chceme dat zoom (na zaciatku a konci, default 1) */
    zoom: {
      start: 4,
      end: 1
    }

  },

  // emocna kamera
  emotion: {

    // ci chceme zmeny aplikovat
    enabled: true,

    /*
     * ako daleko od hraca ma byt kamera
     * typ THREE.Vector3(0, 0, 0) | undefined
     * hodnota undefined zresetuje hodnotu na deafult
     */
    idealOffset: new THREE.Vector3(-1, 1.5, 2),

    /*
     * ako daleko od hraca ma byt bod na ktory sa kamera pozera
     * typ THREE.Vector3(0, 0, 0) | undefined
     * hodnota undefined zresetuje hodnotu na deafult
     */
    idealLookAt: new THREE.Vector3(10, 2 + 0.3, -2),

    /*
     * ako rychlo ma kamera nasledovat hraca
     * typ number | undefined
     * hodnota undefined zresetuje hodnotu na deafult
     */
    coefSize: undefined,

    // velkost lerpu pri zmene kamery
    changeLerp: 1,

    // na aku poziciu v ramci vertikalnej osi davame look at pohlad na hraca
    lookAtPositionY: 1.5

  },

}
